import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-pickerltyp-list-view',
  imports: [],
  templateUrl: './pickerltyp.list-view.html',
  styleUrls: ['./pickerltyp.list-view.css'],
})
export class PickerltypListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
